import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Assets.css';

const Assets = () => {
  const assets = [
    {
      name: 'Kanban Board',
      filename: 'AotB-Board.jpg',
      description: 'The Kanban Board for tracking game progress',
    },
    {
      name: 'Item Sheets',
      filename: 'Item-sheets.pdf',
      description: 'Printable sheets for game items',
      coverImage: 'HP.png',
    },
    {
      name: 'Presentation Slides',
      filename: 'Shapeshifting for Shifting Priorities.pdf',
      description: 'Presentation slides for the game',
      coverImage: 'Shapeshifting for Shifting Priorities.jpg',
    },
  ];

  // Function to get the public URL
  const getPublicUrl = (filename) => {
    return `${window.location.origin}/${filename}`;
  };

  return (
    <>
      <div className="no-print">
        <Link to="/" className="back-link">
          Back to Home
        </Link>
        <h1 className="title">Game Assets</h1>
      </div>
      <div className="assets-container">
        {assets.map((asset, index) => (
          <div key={index} className="asset-card">
            <h2>{asset.name}</h2>
            <div className="asset-image-container">
              {asset.coverImage ? (
                <img
                  src={getPublicUrl(asset.coverImage)}
                  alt={asset.name}
                  className="asset-image"
                />
              ) : (
                <img src={getPublicUrl(asset.filename)} alt={asset.name} className="asset-image" />
              )}
            </div>
            <p>{asset.description}</p>
            <a
              href={getPublicUrl(asset.filename)}
              download={asset.filename}
              className="download-button"
            >
              Download Asset
            </a>
          </div>
        ))}
      </div>
    </>
  );
};

export default Assets;
